module.exports = __webpack_public_path__ + "static/img/mob.dec41ea2.jpeg";